import { Component } from '@angular/core';

import { TmpI18NService } from 'app/i18n/tmp-i18n.service';
import { AccordionPanel } from 'app/shared/model/accordion-panel.model';
import { UserService } from 'app/user/user.service';

import { TrialStartGuideSteps, companyLogoTitleCode } from './trial-start-guide-steps.model';

@Component({
  selector: 'cc-trial-start-guide',
  templateUrl: './trial-start-guide.component.html',
  styleUrls: ['./trial-start-guide.component.scss'],
})
export class TrialStartGuideComponent {
  private readonly texts = {
    thanksForSigningUp: 'thanksForSigningUp',
    welcomeToDashpivot: 'welcomeToDashpivot',
    guideExpiry: 'guideExpiry',
  };

  thanksForSigningUp: string;
  welcomeToDashpivot: string;
  guideExpiry: string;
  trialStartGuidePopulated: AccordionPanel[];

  constructor(private readonly i18nService: TmpI18NService, private readonly userService: UserService) {}

  ngOnInit(): void {
    this.thanksForSigningUp = this.i18nService.getMessage(this.texts.thanksForSigningUp);
    this.welcomeToDashpivot = this.i18nService.getMessage(this.texts.welcomeToDashpivot);
    this.guideExpiry = this.i18nService.getMessage(this.texts.guideExpiry);
    this.trialStartGuidePopulated = this.initializeTrialGuideSteps();
  }

  initializeTrialGuideSteps(): AccordionPanel[] {
    const trialGuideSteps = this.userService.isCompanyControllerOrAbove()
      ? TrialStartGuideSteps
      : TrialStartGuideSteps.filter((step) => step.titleCode !== companyLogoTitleCode);

    return trialGuideSteps.map((panel) => ({
      ...panel,
      titleCode: this.i18nService.getMessage(panel.titleCode),
      textContentCode: this.i18nService.getMessage(panel.textContentCode),
    }));
  }
}
